import { Stack, CardContent, Card, CardHeader } from '@mui/material'
import { Box } from '@mui/system'
import MedconnectDeviceCard from '@/components/ui/cards/MedconnectDevicesCard/MedconnectDeviceCard'
import { useTranslation } from 'react-i18next'

export type DeviceData = {
  src: string
  name: string
  id: string
  onClick: () => void
}

type SelectDeviceProps = {
  devices: DeviceData[]
}

export default function SelectDevice(props: SelectDeviceProps) {
  const { devices } = props
  const { t } = useTranslation()
  return (
    <Card>
      <CardHeader title={t('component.ui.deviceSelectionDialog.tab.customDevices')} />
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
          <Stack direction="row" sx={{ mb: 2, gapRight: '10px' }} flexWrap="wrap" columnGap={'10px'} rowGap={'10px'}>
            {devices.map((device) => (
              <MedconnectDeviceCard key={device.id} logoSrc={device.src} name={device.name} connectDevice={device.onClick} isLocal={true} noButton={true} />
            ))}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  )
}
